// disabling tslint because it doesn't like giving resolve to setTimeout
/* tslint:disable */
export default function sleep(t: number) {
    return new Promise(resolve => setTimeout(resolve, t));
}
/* tslint:enable */